export default __webpack_public_path__ + "static/media/jolt-100-1.9bb7b245.jpg";